<script>
      import Pagina from "../componentes/formato/PaginaBase.svelte";
</script>

<Pagina>
      <h3>NOT FOUND</h3>
</Pagina>
